import React from 'react'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'

import { Wizard } from '@xengage/gw-portals-wizard-react';

import wizardConfig from './config/agent-registration-wizard-config.json5'
import messages from './templates/AgentRegistrationWizardTemplate.messages'

export const AgentRegistrationWizard = () => {
    const location = useLocation();
    const { steps, title } = wizardConfig;

    return (
      <Wizard
          initialSteps={steps}
          wizardTitle={title}
          initialData={{}}
          location={location}
          // DE15241
          onPreviousModalProps = {{ title: messages.sideNavTitle,
            message: messages.sideNavMessage,
            status: 'warning',
            icon: 'gw-help-outline',
            confirmButtonText: messages.okButtonMsg,
            cancelButtonText: messages.cancelButtonMsg,
        }}
      />

    )
}